module.exports = __webpack_public_path__ + "img/avto-recxva.22d3643f.png";